import styled from 'styled-components';
import { DivCheckboxBlock } from '../TextBox/styles';

export const DivCheckboxBlockList = styled(DivCheckboxBlock)`
  margin-top: 5px !important;
  height: auto;
`;
